import { useEffect, useState, useCallback } from 'react';
import { getHistory } from '../../modules/history';
import { useTypedSelector } from '../../types/global';
import { selectEnvironment } from '../../modules/global';
import applicationListSelectors from '../../modules/application/list/applicationListSelectors';
import { accountVerificationStorage } from '../../view/AccountVerificationPage/accountVerificationStorage';
import {
  BadgeType,
  MenuItemBadgeRegistry,
} from '../../utils/MenuItemBadgeRegistry';
import { VERIFICATION_DOCS_URLS } from '../../utils/constants';
import { isKSACountry } from '../../config/countriesEnvironments';

export function useAvsPromotionBannerHandler(): {
  isVisible: boolean;
  setIsVisible: (visible: boolean) => void;
  handleTryNow: () => void;
  handleReadDocumentation?: () => void;
} {
  const history = getHistory();
  const environment = useTypedSelector(selectEnvironment);
  const application = useTypedSelector(
    applicationListSelectors.selectApplication,
  );

  const [isVisible, setIsVisible] = useState(() =>
    application?.id
      ? accountVerificationStorage.shouldShowBanner(environment, application.id)
      : false,
  );

  useEffect(() => {
    if (application?.id) {
      accountVerificationStorage.initializeBannerFirstSeen(
        environment,
        application.id,
      );
    }
  }, [environment, application?.id]);

  const handleTryNow = () => {
    if (application?.id) {
      history.push(`/id/${application.id}/account-verification`);
      accountVerificationStorage.dismissBanner(environment, application.id);
      accountVerificationStorage.recordAvsPageVisit(
        environment,
        application.id,
      );
      setIsVisible(false);
    }
  };

  const handleReadDocumentation = () => {
    if (application?.id) {
      window.open(
        isKSACountry ? VERIFICATION_DOCS_URLS.KSA : VERIFICATION_DOCS_URLS.UAE,
        '_blank',
      );
    }
  };

  useEffect(() => {
    if (!isVisible) {
      if (
        accountVerificationStorage.shouldShowNewNavigationItem(
          environment,
          application?.id,
        )
      ) {
        MenuItemBadgeRegistry.register('Account Verification', {
          shouldShow: true,
          type: BadgeType.Badge,
          label: 'NEW',
          description: "Confirm your customer's account ownership in seconds",
        });
      }
    } else {
      MenuItemBadgeRegistry.register('Account Verification', {
        shouldShow: true,
        type: BadgeType.Dot,
      });
    }
  }, [isVisible, environment, application?.id]);

  return {
    isVisible,
    setIsVisible,
    handleTryNow,
    handleReadDocumentation,
  };
}
